import { render, staticRenderFns } from "./GeneralResults.vue?vue&type=template&id=8e08c016"
import script from "./GeneralResults.vue?vue&type=script&lang=js"
export * from "./GeneralResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports